export default "__VITE_ASSET__22722799__"